import { DownloadOutlined } from "@ant-design/icons";
import { Button, Tag, Typography } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const { Title, Text } = Typography;
export function getPaymentName(paymentId) {
  const paymentMap = {
    1: "authorizeNet",
    2: "cash",
    3: "card",
    4: "refund",
    10: "bankTransfer",
    13: "wechat",
    21: "square",
    35: "stripe",
    22: "aliPay",
    23: "clover",
    24: "paypal",
    25: "heartland",
    26: "paypalInStore",
    27: "broadPOS",
    28: "limitedSpend",
    31: "interswitch",
    32: "horizonPay",
    33: "ebt",
    34: "Worldnet",
    50: "splitTender",
    36: "Elavon",
    37: "intelifin",
    38: "elavonEbt",
    39: "redeemCode",
    40: "customerInvoice",
    12: "masterPass",
    14: "flutterWave",
    15: "zeroAmount",
    16: "scratchCard",
    17: "ravePayment",
    18: "FBNUSSD",
    19: "braintreeGateway",
    20: "payaConnect",
    41: "payByBank",
    42: "monetra",
    43: "monetraEbt",
    44: "Gift Card",
    45: "monetraCustomerInvoice",
    47: "payTheory",
    48: "valor",
    49: "valorEbt",
    1000: "FreedomPay",
    1001: "freedomPayCustomerInvoice",
    1002: "freedomPayEbt",
    967: "elavonCheck",
    968: "elavonWizarPos",
    1003: "NMIPay",
    1050: "Crypto",
    1051: "smartpay",
    1005: "Evo",
    1300: "EvoEservice",
    1327: "Payrix",
    1331: "wizarPosEbt",
  };

  if (paymentId !== undefined && paymentId !== null && paymentId !== "") {
    return paymentMap[paymentId] || "";
  } else if (paymentId == -1) {
    return "Card";
  } else {
    return paymentMap;
  }
}

export const getPaymentStatusInfo = (status) => {
  // Handle both numeric and string status values
  switch (status) {
    case 1: // SUCCESS
    case "Paid":
      return { color: "#30649b", name: "Paid" };

    case 0: // FAILED
    case "Unpaid":
      return { color: "#F7D95F", name: "Unpaid" };

    case 2: // PENDING
    case "Pending":
      return { color: "#d46b08", name: "Pending" };

    case 3: // PRE_AUTH
      return { color: "#531dab", name: "Pre-Auth" };

    case 4: // AUTH_INCREMENT
      return { color: "info", name: "Auth Increment" };

    case 5: // TIP_ADJUST
      return { color: "#1d39c4", name: "Tip Adjust" };

    default:
      return { color: "default", name: "Unknown" };
  }
};

const handleDownloadReceipt = (splitBill, index) => {
  if (!splitBill) return;
  const payments = splitBill?.split_checks?.[index]?.payments;
  if (payments.length === 0) return;

  const printWindow = window.open();
  const currencySign = "$"; // Assuming USD currency
  const paymentTypeId = splitBill?.split_checks?.[index]?.payments?.[0]?.paymentTypeId;

  // Extract data from the split bill
  const order = splitBill.order || {};
  const employee = splitBill.employee || order.employee || {};
  const orgTable = order.org_table || {};
  const orderPayments = order.order_payments || [];
  const splitChecks = splitBill.split_checks || [];

  // Get the specific check by index
  const specificCheck = splitChecks[index];
  if (!specificCheck) {
    printWindow.document.write("<h3>Check not found</h3>");
    printWindow.document.close();
    return;
  }

  // Current date and time
  const now = new Date();
  const orderDate = now.toLocaleDateString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const orderTime = now.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  // Calculate totals for the specific check
  const items = specificCheck.items || [];
  const subtotal = parseFloat(specificCheck.amount);
  const totalDiscount = items.reduce(
    (sum, item) => sum + parseFloat(item.order_product?.discountAmount || 0),
    0
  );
  const totalTax = items.reduce(
    (sum, item) => sum + parseFloat(item.order_product?.taxAmount || 0),
    0
  );
  const total = subtotal - totalDiscount + totalTax;

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Receipt - Check ${specificCheck.check_number}</title>
        <style>
          * {
            font-size: 16px;
            margin: 0px;
            font-family: 'Times New Roman', serif;
          }
          body {
            max-width: 300px;
            margin: 0 auto;
            padding: 10px;
            color: #000000;
          }
          td, 
          th,
          tr,
          table {
            border-collapse: collapse;
          }
          
          td.quantity,
          th.quantity {
            width: 70%;
            max-width: 70%;
            word-break: break-all;
          }

          td.price,
          th.price {
            width: 30%;
            max-width: 30%;
            word-break: break-all;
            text-align: right;
            align-content: end;
          }

          .centered {
            text-align: center;
            align-content: center;
          }

          .ticket {
            width: 300px;
            max-width: 300px;
          }
          
          .voided-transaction {
            color: red;
            font-weight: bold;
            font-size: 20px;
          }
          
          .text_blue {
            color: blue;
          }
          
          .divider {
            border-top: 1px dashed #666;
            margin: 10px 0;
            padding: 5px 0;
          }
          
          @media print {
            .hidden-print,
            .hidden-print * {
              display: none !important;
            }
          }
        </style>
      </head>
      <body onload="window.print(); window.onafterprint = function() { window.close(); }">
        <div class="ticket">
          <p class="centered">
            <span style="font-size: 26px; font-weight: 900;">${orgTable.orgTableId || "Table 05"
    }</span>
            <br>
            <span style="font-size: 20px;">Check ${specificCheck.check_number
    } Receipt</span>
            <br>
            <span style="font-size: 16px; font-weight: 900;">${orderDate} [${orderTime}]</span>
          </p>
          
          ${order.invoiceNo
      ? `
            <div class="centered" style="margin: 15px 0;">
              <h5 style="letter-spacing: 5px; margin-top: 2px; margin-bottom: 0px;">
                ORDER #${order.invoiceNo}
              </h5>
            </div>
          `
      : ""
    }
          
          <div style="width: 100%;">
            ${order.invoiceNo
      ? `
              <p style="margin: 0px;">Receipt No.: ${order.invoiceNo}</p>
            `
      : ""
    }
            
            <p style="margin: 0px;">
              Action: ${order.totalAmount >= 0 ? "Sale" : "Refund"}
            </p>
            
            <p style="margin: 0px;">
              Sales Person: ${employee.firstName || ""} ${employee.lastName || ""
    }
            </p>
            
            <p style="margin: 0px;">
              Table: ${orgTable.orgTableName || "N/A"}
            </p>
            
            <p style="margin: 0px;">
              Check: ${specificCheck.check_number}
            </p>
            
            ${order.isIdCheckVerified === 1
      ? `
              <p class="text_blue">ID was Verified</p>
            `
      : ""
    }
          </div>
          
          <div class="divider"></div>
          
          <div style="font-size: 18px; font-weight: 900; margin-bottom: 10px;">
            Items
          </div>
          
          ${items.length === 0
      ? `
            <div>No items available</div>
          `
      : `
            <table style="width: 100%;">
              <tbody>
                ${items
        .map(
          (item) => `
                  <tr>
                    <td class="quantity" style="padding-top: 5px;">
                      ${item.order_product?.productName || "N/A"}
                      <br>
                      ${item.order_product?.quantity || "1"} × $${parseFloat(
            item.order_product?.productPrice || 0
          ).toFixed(2)}
                      ${item.order_product?.taxAmount > 0
              ? `(+$${parseFloat(
                item.order_product?.taxAmount || 0
              ).toFixed(2)} tax)`
              : ""
            }
                      ${item.order_product?.discountAmount > 0
              ? `(-$${parseFloat(
                item.order_product?.discountAmount || 0
              ).toFixed(2)} discount)`
              : ""
            }
                    </td>
                    <td class="price" style="vertical-align: bottom;">
                      $${parseFloat(
              item.order_product?.totalProductAmount || 0
            ).toFixed(2)}
                    </td>
                  </tr>
                `
        )
        .join("")}
              </tbody>
            </table>
          `
    }
          
          <div class="divider"></div>
          
          <div style="font-size: 18px; font-weight: 900; margin-bottom: 10px;">
            Check Summary
          </div>
          
          <table style="width: 100%;">
            <tbody>
              <tr>
                <td class="quantity">Subtotal</td>
                <td class="price">$${subtotal.toFixed(2)}</td>
              </tr>
              ${totalDiscount > 0
      ? `
                <tr>
                  <td class="quantity">Discount</td>
                  <td class="price">-$${totalDiscount.toFixed(2)}</td>
                </tr>
              `
      : ""
    }
              ${totalTax > 0
      ? `
                <tr>
                  <td class="quantity">Tax</td>
                  <td class="price">$${totalTax.toFixed(2)}</td>
                </tr>
              `
      : ""
    }
              <tr>
                <td class="quantity" style="border-top: 1px dashed #666; padding-top: 10px; font-weight: bold;">
                  CHECK TOTAL
                </td>
                <td class="price" style="border-top: 1px dashed #666; padding-top: 10px; font-weight: bold;">
                  $${total.toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
          
          <div class="divider"></div>
          
          
          
          <div class="divider"></div>
          
          <div style="font-size: 18px; font-weight: 900; margin-bottom: 10px;">
            Payment Details
          </div>
          
         ${orderPayments.length === 0
      ? `
  <div>No payment information available</div>
`
      : `
  <div style="margin-bottom: 10px; border-bottom: 1px dashed #ccc; padding-bottom: 10px;">
    <div style="display: flex; justify-content: space-between;">
      <span>Amount:</span>
      <span>$${orderPayments[index]
        ? parseFloat(orderPayments[index].amount) ==
          parseFloat(specificCheck.amount)
          ? orderPayments[index].amount
          : total
        : total
      }</span>
    </div>
    <div style="display: flex; justify-content: space-between;">
      <span>Method:</span>
      <span style="text-transform: capitalize;">${orderPayments[index]
        ? getPaymentName(paymentTypeId)
        : "-"
      }</span>
    </div>
    <div style="display: flex; justify-content: space-between;">
      <span>Status:</span>
      <span>${orderPayments[index]
        ? orderPayments[index].paymentStatus === 1
          ? "Completed"
          : "Pending"
        : orderPayments[0]
          ? orderPayments[0].paymentStatus === 1
            ? "Completed"
            : "Pending"
          : "Pending"
      }</span>
    </div>
    ${orderPayments[index]
        ? orderPayments[index].transactionDate
          ? `
      <div style="display: flex; justify-content: space-between;">
        <span>Date:</span>
        <span>${new Date(
            orderPayments[index].transactionDate
          ).toLocaleString()}</span>
      </div>
    `
          : ""
        : orderPayments[0]
          ? orderPayments[0].transactionDate
            ? `
      <div style="display: flex; justify-content: space-between;">
        <span>Date:</span>
        <span>${new Date(
              orderPayments[0].transactionDate
            ).toLocaleString()}</span>
      </div>
    `
            : ""
          : ""
      }
  </div>
`
    }
          
          <div class="divider"></div>
          
          <div style="font-size: 14px; font-weight: bold; margin-bottom: 5px;">
            Return Policy:
          </div>
          <div style="font-size: 12px;">
            Returns Now Not Accepted
          </div>
          
          <p class="centered" style="font-size: 20px; font-weight: 900; margin-top: 20px;">
            Thank You
          </p>
          
          <p class="centered" style="font-size: 12px; margin-top: 10px;">
            ${order.createDt
      ? `Created: ${new Date(order.createDt).toLocaleString()}`
      : ""
    }
          </p>
        </div>
      </body>
    </html>
  `);

  printWindow.document.close();
};
export function Itemcolumns() {
  return [
    {
      title: "Amount",
      dataIndex: "totalPaid",
      key: "totalPaid",
      render: (paid) => {
        const amount = typeof paid === "number" ? paid.toFixed(2) : "0.00";
        return <strong>${amount}</strong>;
      },
    },
    {
      title: "Tip",
      dataIndex: "tipAmount",
      key: "tipAmount",
      render: (tip) => {
        const tipAmount = typeof tip === "number" ? tip.toFixed(2) : "0.00";
        return `$${tipAmount}`;
      },
    },
    {
      title: "Items",
      dataIndex: "items",
      key: "items",
      render: (_, record) => {
        const itemCount = record.items?.length ?? 0;
        return `${itemCount} Items`;
      },
    },
    {
      title: "Payment Type",
      dataIndex: "paymentType",
      key: "paymentType",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record, order, index) => {
        const statusInfo = getPaymentStatusInfo(status);
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span
              style={{
                backgroundColor: statusInfo.color,
                color: "white",
                padding: "2px 8px",
                borderRadius: "4px",
                fontSize: "12px",
              }}
            >
              {statusInfo.name}
            </span>
            <Button
              type="text"
              icon={<DownloadOutlined />}
              size="small"
              onClick={() => handleDownloadReceipt(order, index)}
            />
          </div>
        );
      },
    },
  ];
}

export function Customcolumns() {
  return [
    {
      title: "Seat",
      dataIndex: "seat",
      key: "seat",
      render: (_, record) => {
        return `${record.guestLabel}`;
      },
    },
    {
      title: "Amount",
      dataIndex: "totalPaid",
      key: "totalPaid",
      render: (paid) => {
        const amount = typeof paid === "number" ? paid.toFixed(2) : "0.00";
        return <strong>${amount}</strong>;
      },
    },
    {
      title: "Tip",
      dataIndex: "tipAmount",
      key: "tipAmount",
      render: (tip) => {
        const tipAmount = typeof tip === "number" ? tip.toFixed(2) : "0.00";
        return `$${tipAmount}`;
      },
    },
    {
      title: "Payment Type",
      dataIndex: "paymentType",
      key: "paymentType",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record, order, index) => {
        const statusInfo = getPaymentStatusInfo(status);
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span
              style={{
                backgroundColor: statusInfo.color,
                color: "white",
                padding: "2px 8px",
                borderRadius: "4px",
                fontSize: "12px",
              }}
            >
              {statusInfo.name}
            </span>
            <Button
              type="text"
              icon={<DownloadOutlined />}
              size="small"
              onClick={() => handleDownloadReceipt(order, index)}
            />
          </div>
        );
      },
    },
  ];
}

export function Evencolumns() {
  return [
    {
      title: "Seat",
      dataIndex: "seat",
      key: "seat",
      render: (_, record) => {
        return `${record.guestLabel}`;
      },
    },
    {
      title: "Amount",
      dataIndex: "totalPaid",
      key: "totalPaid",
      render: (paid) => {
        const amount = typeof paid === "number" ? paid.toFixed(2) : "0.00";
        return <strong>${amount}</strong>;
      },
    },
    {
      title: "Tip",
      dataIndex: "tipAmount",
      key: "tipAmount",
      render: (tip) => {
        const tipAmount = typeof tip === "number" ? tip.toFixed(2) : "0.00";
        return `$${tipAmount}`;
      },
    },
    {
      title: "Payment Type",
      dataIndex: "paymentType",
      key: "paymentType",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, _, order, index) => {
        const statusInfo = getPaymentStatusInfo(status);
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span
              style={{
                backgroundColor: statusInfo.color,
                color: "white",
                padding: "2px 8px",
                borderRadius: "4px",
                fontSize: "12px",
              }}
            >
              {statusInfo.name}
            </span>
            <Button
              type="text"
              icon={<DownloadOutlined />}
              size="small"
              onClick={() => handleDownloadReceipt(order, index)}
            />
          </div>
        );
      },
    },
  ];
}

export function Seatcolumns() {
  return [
    {
      title: "Seat",
      dataIndex: "seat",
      key: "seat",
      render: (_, record) => {
        return `${record.guestLabel}`;
      },
    },
    {
      title: "Amount",
      dataIndex: "totalPaid",
      key: "totalPaid",
      render: (paid) => {
        const amount = typeof paid === "number" ? paid.toFixed(2) : "0.00";
        return <strong>${amount}</strong>;
      },
    },
    {
      title: "Tip",
      dataIndex: "tipAmount",
      key: "tipAmount",
      render: (tip) => {
        const tipAmount = typeof tip === "number" ? tip.toFixed(2) : "0.00";
        return `$${tipAmount}`;
      },
    },
    {
      title: "Payment Type",
      dataIndex: "paymentType",
      key: "paymentType",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, _, order, index) => {
        const statusInfo = getPaymentStatusInfo(status);
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span
              style={{
                backgroundColor: statusInfo.color,
                color: "white",
                padding: "2px 8px",
                borderRadius: "4px",
                fontSize: "12px",
              }}
            >
              {statusInfo.name}
            </span>
            <Button
              type="text"
              icon={<DownloadOutlined />}
              size="small"
              onClick={() => handleDownloadReceipt(order, index)}
            />
          </div>
        );
      },
    },
  ];
}

export function Percentagecolumns() {
  return [
    {
      title: "Seat",
      dataIndex: "seat",
      key: "seat",
      render: (_, record) => {
        return `${record.guestLabel}`;
      },
    },
    {
      title: "Amount",
      dataIndex: "totalPaid",
      key: "totalPaid",
      render: (paid) => {
        const amount = typeof paid === "number" ? paid.toFixed(2) : "0.00";
        return <strong>${amount}</strong>;
      },
    },
    {
      title: "Tip",
      dataIndex: "tipAmount",
      key: "tipAmount",
      render: (tip) => {
        const tipAmount = typeof tip === "number" ? tip.toFixed(2) : "0.00";
        return `$${tipAmount}`;
      },
    },
    {
      title: "Percentage",
      dataIndex: "percentage",
      key: "percentage",
      render: (percentage) => {
        return `${percentage} %`;
      },
    },
    {
      title: "Payment Type",
      dataIndex: "paymentType",
      key: "paymentType",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record, order, index) => {
        const statusInfo = getPaymentStatusInfo(status);
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span
              style={{
                backgroundColor: statusInfo.color,
                color: "white",
                padding: "2px 8px",
                borderRadius: "4px",
                fontSize: "12px",
              }}
            >
              {statusInfo.name}
            </span>
            <Button
              type="text"
              icon={<DownloadOutlined />}
              size="small"
              onClick={() => handleDownloadReceipt(order, index)}
            />
          </div>
        );
      },
    },
  ];
}

export function defaultcolumns() {
  return [
    {
      title: "Amount",
      dataIndex: "totalPaid",
      key: "totalPaid",
      render: (paid) => {
        const amount = typeof paid === "number" ? paid.toFixed(2) : "0.00";
        return <strong>${amount}</strong>;
      },
    },
    {
      title: "Tip",
      dataIndex: "tipAmount",
      key: "tipAmount",
      render: (tip) => {
        const tipAmount = typeof tip === "number" ? tip.toFixed(2) : "0.00";
        return `$${tipAmount}`;
      },
    },
    {
      title: "Payment Type",
      dataIndex: "paymentType",
      key: "paymentType",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record, order, index) => {
        const statusInfo = getPaymentStatusInfo(status);
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span
              style={{
                backgroundColor: statusInfo.color,
                color: "white",
                padding: "2px 8px",
                borderRadius: "4px",
                fontSize: "12px",
              }}
            >
              {statusInfo.name}
            </span>
            <Button
              type="text"
              icon={<DownloadOutlined />}
              size="small"
              onClick={() => handleDownloadReceipt(order, index)}
            />
          </div>
        );
      },
    },
  ];
}
